module.exports = __webpack_public_path__ + "static/media/background_1.2878c67e.jpg";